import { render, staticRenderFns } from "./ClaimStagingReview.vue?vue&type=template&id=61970bfc&"
import script from "./ClaimStagingReview.vue?vue&type=script&lang=js&"
export * from "./ClaimStagingReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimStagingReview.vue"
export default component.exports